import List from './components/List'
import Form from './components/Form'

export default [
  {path: '/institution_unit', component: List, name: 'institution_unit.index'},
  {path: '/institution_unit/store', component: Form, name: 'institution_unit.store'},
  {path: '/institution_unit/:id', component: Form, name: 'institution_unit.update'}
]



// WEBPACK FOOTER //
// ./src/app/domains/institution_unit/routes.js